// Spec 083 (T030) — os tipos de domínio do relatório, 1:1 com o hook dono da lógica.
//
// Tudo vem de `z.infer` do contrato: divergir daqui falha na compilação, que é o ponto.
export type {
  ProductionReportQuery,
  ProductionReportResponse,
  ReportBucket,
  ReportComparison,
  ReportComparisonColumn,
  ReportFilter,
  ReportGroupBy,
  ReportIndicator,
  ReportInput,
  ReportLossItem,
  ReportPreset,
  ReportProductItem,
  ReportScopeKind,
  ReportStage,
} from "@opus-dt/shared-types";

/** Modo da grade de fechamento. Resumida abre; completa é a planilha, coluna por coluna. */
export type ClosingGridMode = "summary" | "full";

/** Quantos produtos a grade resumida mostra antes de agregar o resto em "Outros". */
export const SUMMARY_TOP_PRODUCTS = 3;

export const GROUP_BY_LABELS: Record<string, string> = {
  day: "Dia",
  week: "Semana",
  month: "Mês",
};

export const PRESET_LABELS: Record<string, string> = {
  "7d": "7 dias",
  "30d": "30 dias",
  thisMonth: "Este mês",
  lastMonth: "Mês passado",
  thisYear: "Este ano",
  custom: "Personalizado",
};
